import React, { useState, useEffect } from "react";
import {
  Space,
  Card,
  Layout,
  Form,
  Input,
  Button,
  Table,
  message,
  Row,
  Col,
  Select,
  Tag,
  Timeline,
  List,
  Avatar,
} from "antd";
import {
  FileSyncOutlined,
  MenuOutlined,
  UserOutlined,
} from "@ant-design/icons";
import SideBar from "./_sideBar";
import CopyRight from "./CopyRight";
import axios from "axios";
import moment from "moment";

const CoreTransactionManagement = () => {
  const { Content } = Layout;
  const [menuDisabled, setMenuDisabled] = useState(false);
  const [nextMenuDisabled, setNextMenuDisabled] = useState(false);
  const [form] = Form.useForm();
  const [tableData, setTableData] = useState([]); // State for table data
  const [loading, setLoading] = useState(false);
  const [merchant, setMerchant] = useState();
  const [loginUser, setLoginUser] = useState();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const loginUserToken = JSON.parse(localStorage.getItem("loginUserToken"));
  const user = JSON.parse(localStorage.getItem("loginUser"));
  useEffect(() => {
    setLoginUser(user);

    getMerchantData();

    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [form]);

  const getMerchantData = async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_BACKEND_URL}/v1/merchant/findAllMerchantAndSubMerchant`,
      {
        headers: {
          Authorization: `Bearer ${loginUserToken}`,
        },
      }
    );
    const data = res.data;

    form.setFieldsValue({
      merchantCode: data[0]?.merchantCode, // You can choose the first merchant or provide a default
    });

    setMerchant(data.flatMap((m) => m.merchant));
  };

  // Submit handler for the form
  const onFinish = async (values) => {
    try {
      setLoading(true);

      // Send POST request to the backend
      const response = await axios.post(
        `${process.env.REACT_APP_API_BACKEND_URL}/v1/enquiry/findTransactionByInvoiceNo`,
        null, // No body for the POST request
        {
          headers: {
            Authorization: `Bearer ${loginUserToken}`,
          },
          params: {
            merchantCode: values.merchantCode, // Query parameters go here
            invoiceNo: values.invoiceNo,
          },
        }
      );

      console.log("Transaction Data", response.data);

      // Update table data with response
      setTableData([response.data]);
      // setTableData((prevData) => [...prevData, response.data]);
      // message.success("Transaction added successfully!");
      form.resetFields(); // Reset form after successful submission
    } catch (error) {
      console.error("Error submitting data:", error);
      message.error("Failed to submit transaction.");
    } finally {
      setLoading(false);
    }
  };

  const handleQueryOrder = async (merchantCode, invoiceNo) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BACKEND_URL}/v1/enquiry/callbackCore`,
        null, // No body for the POST request
        {
          headers: {
            Authorization: `Bearer ${loginUserToken}`,
          },
          params: {
            merchantCode,
            invoiceNo,
          },
        }
      );

      console.log("QUERY ORDER RESPONSE", response.data);

      if (response.data === "success") {
        // Show success message
        message.success("This payment transaction successfully send to core.");
      } else {
        message.error("This payment transaction has failed. Please try again.");
      }
    } catch (error) {
      console.error("Error querying order:", error);
      message.error("Error occurred while querying order.");
    }
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <SideBar
        menuDisabled={menuDisabled}
        nextMenuDisabled={nextMenuDisabled}
        fontSize="14px"
        drawerVisibleValue={drawerVisible}
        setDrawerVisibleValue={setDrawerVisible}
      />

      <Layout className="site-layout">
        <Content>
          <div className="site-layout-background" style={{ minHeight: 360 }}>
            <Space
              direction="vertical"
              style={{ padding: "10px", width: "100%" }}
            >
              <Card
                title={
                  <span>
                    {isMobile && (
                      <MenuOutlined
                        onClick={() => setDrawerVisible((prev) => !prev)}
                        style={{ marginRight: 8, fontSize: 30 }}
                      />
                    )}
                    <FileSyncOutlined style={{ marginRight: 8 }} />
                    Callback Core
                  </span>
                }
                headStyle={{ backgroundColor: "#cccccc" }}
                extra={
                  <span>
                    {loginUser?.username}
                    <Avatar
                      src={loginUser?.avatarUrl}
                      icon={!loginUser?.avatarUrl && <UserOutlined />}
                      style={{ marginLeft: 8 }}
                    />
                  </span>
                }
              >
                {/* Ant Design Form */}
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={onFinish}
                  style={{
                    maxWidth: "1000px",
                    margin: "0 auto",
                  }}
                >
                  <Row gutter={16}>
                    <Col xs={24} sm={12}>
                      <Form.Item name="merchantCode" hidden>
                        <Input type="hidden" />
                      </Form.Item>
                      <Form.Item label="Merchant Name" name="merchantCode">
                        <Select placeholder="Select Merchant Name" allowClear>
                          {merchant?.map((s) => (
                            <Select.Option
                              key={s.merchantCode}
                              value={s.merchantCode}
                            >
                              {s.name}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        label="Invoice Number/Order ID"
                        name="invoiceNo"
                        rules={[
                          {
                            required: true,
                            message: "Please enter Invoice No.!",
                          },
                        ]}
                      >
                        <Input placeholder="Enter Invoice No." />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading}>
                      Submit
                    </Button>
                  </Form.Item>
                </Form>
              </Card>

              {tableData.length > 0 ? (
                <List
                  bordered
                  dataSource={tableData}
                  renderItem={(item) => (
                    <List.Item>
                      <div style={{ width: "100%" }}>
                        <h4>Invoice No: {item.invoiceNo}</h4>
                        <p>
                          <strong>Date/Time:</strong>{" "}
                          {moment(item.dateTime).format("DD/MM/YYYY HH:mm:ss")}
                        </p>
                        <p>
                          <strong>Merchant Name:</strong> {item.merchantCode}
                        </p>
                        <p>
                          <strong>SubMerchant Name:</strong>{" "}
                          {item.subMerchantCode}
                        </p>
                        <p>
                          <strong>Transaction Amount:</strong> MMK{" "}
                          {item.amount.toLocaleString()}
                        </p>
                        <p>
                          <strong>Product Description:</strong>{" "}
                          {item.description}
                        </p>
                        <p>
                          <strong>Status:</strong>{" "}
                          <Tag
                            color={
                              item.status === "SUCCESS" ? "green" : "orange"
                            }
                          >
                            {item.status}
                          </Tag>
                        </p>

                        <p>
                          <Button
                            htmlType="button"
                            type="primary"
                            onClick={() =>
                              handleQueryOrder(
                                item.merchantCode,
                                item.invoiceNo
                              )
                            }
                          >
                            Callback Core
                          </Button>
                        </p>
                      </div>
                    </List.Item>
                  )}
                />
              ) : (
                <p>No data available</p>
              )}
            </Space>
          </div>
          <CopyRight />
        </Content>
      </Layout>
    </Layout>
  );
};

export default CoreTransactionManagement;
